import React from 'react';
export const SquaresArrow = ({ direction = 'right', ...props }) => {
    const isLeftDirection = direction === 'left';
    return (React.createElement("svg", { role: "presentation", xmlns: "http://www.w3.org/2000/svg", style: { transform: isLeftDirection ? 'rotate(180deg)' : undefined }, ...props },
        React.createElement("path", { d: "M0.002621 23.998L8.00195 31.9976L16.0013 23.998L8.00195 15.9985L0.002621 23.998Z", fill: "#0047AD" }),
        React.createElement("path", { d: "M8.00128 15.9985L16.0006 23.998L23.9999 15.9985L16.0006 7.99897L8.00128 15.9985Z", fill: "#40A0FF" }),
        React.createElement("path", { d: "M0.002621 7.999L8.00195 15.9985L16.0013 7.999L8.00195 -0.000537725L0.002621 7.999Z", fill: "#0072EB" })));
};
